
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 .5H2A1.5 1.5 0 00.5 2v10A1.5 1.5 0 002 13.5h18a1.5 1.5 0 001.5-1.5V2A1.5 1.5 0 0020 .5z","stroke":"#5EA9FF"}}),_c('path',{attrs:{"d":"M3.582 4.188l1.934 5.564h1.12l1.921-5.565H7.388l-1.289 4.19-1.327-4.19h-1.19zm8.8 5.564h1.22l-1.233-2.41a1.508 1.508 0 001.005-1.466c0-1.168-.7-1.689-2.533-1.689H9.015v5.564h1.1v-2.18h1.164l1.103 2.18zm-1.42-4.7c.744 0 1.282.192 1.282.837 0 .552-.368.837-1.228.837h-.903V5.048l.849.003zm3.246 4.7h1.1v-2.4h2.793v-.89h-2.793V5.078h2.955v-.89h-4.052l-.003 5.564z","fill":"#5EA9FF"}})])
          )
        }
      }
    